/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { Button, Collapse, Popconfirm } from 'antd';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import FuelUplift from './FuelUplift';

const { Panel } = Collapse;

const updateArray = (arr, index, value) => arr.map((x, i) => (index === i ? value : x));

const FuelUplifts = ({ value = [], active, aircraft, onActive, onChange, formItemLayout, ...props }, ref) => {
  const { formatMessage } = useIntl();
  return (
    <Collapse ref={ref} accordion activeKey={active} onChange={onActive} bordered={value.length !== 0}>
      {value.map((uplift, i) => (
        <Panel
          header={
            <span>
              {formatMessage({ id: 'title.uplift' })} {uplift.aircraft_actual_uplift}
              {aircraft.fuel_unit}
            </span>
          }
          // Deice events do not have unique ids
          // eslint-disable-next-line react/no-array-index-key
          key={uplift.id}
          extra={
            <Popconfirm
              title={formatMessage({ id: 'form.question.confirmUpliftDelete' })}
              okText={formatMessage({ id: 'form.button.yes' })}
              cancelText={formatMessage({ id: 'form.button.no' })}
              placement="topRight"
              onClick={(e) => e.stopPropagation()}
              onCancel={(e) => e.stopPropagation()}
              onConfirm={() => onChange(value.filter((x, index) => index !== i))}
            >
              <Button type="danger" size="small">
                {formatMessage({ id: 'form.button.delete' })}
              </Button>
            </Popconfirm>
          }
        >
          <FuelUplift
            formItemLayout={formItemLayout}
            value={uplift}
            onChange={(v) => onChange(updateArray(value, i, v))}
            aircraft={aircraft}
            {...props}
          />
        </Panel>
      ))}
    </Collapse>
  );
};

FuelUplifts.propTypes = {
  aircraft: PropTypes.object.isRequired,
  value: PropTypes.array,
  active: PropTypes.bool.isRequired,
  onActive: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  formItemLayout: PropTypes.object.isRequired,
};

FuelUplifts.defaultProps = {
  value: [],
  onChange: undefined,
};

// forwardRef necessary for antd form components
export default forwardRef(FuelUplifts);
